<template>
  <NuxtLayout name="catalog">
    <div class="empty-group">
      <div class="page-container">
        <MoleculesGlobalBreadcrumb :segments="entity.parents"></MoleculesGlobalBreadcrumb>
      </div>

      <!-- heading with annotation -->

      <div class="my-8 py-8 bg-neutral-100">
        <div class="page-container !max-w-[1000px]">
          <h1 class="text-4xl font-bold tracking-normal after:content-[''] after:block after:mt-6 after:mb-6 after:w-[40px] after:border-b-2 after:border-secondary-500">{{ entity.page.header }}</h1>
          <div v-html="entity.annotation"></div>
        </div>
      </div>

      <!-- message -->

      <div class="page-container">
        <div class="py-12 text-center text-warning-500">
          <AtomsImagesIcon icon="circled-cross" class="text-[4rem]" />
          <div class="mt-8 text-3xl font-bold">{{ $t('Bohužel, z této kategorie nenabízíme již žádné zboží') }}</div>
        </div>
      </div>

      <!-- search -->

      <div class="my-8 p-8 bg-neutral-100">
        <AtomsContainersCornerBorders class="empty-group__block">
          <AtomsImagesIcon icon="magnifying-glass" class="text-[4rem]" />
          <div class="empty-group__block__desc">{{ $t('Zatímco čekáte na další dobrodružství, proč se nepodívat na naši širokou nabídku?') }}</div>
          <MoleculesButtonsButton :arrow-right="true" @click="openSearch">{{ $t('Přejít k výběru') }}</MoleculesButtonsButton>
        </AtomsContainersCornerBorders>
      </div>

      <!-- new stuff -->

      <div class="page-container">
        <TemplatesNewItems class="desktop:-mb-12" />
      </div>

      <!-- theme groups -->

      <div class="my-8 bg-neutral-100">
        <TemplatesThemeGroups :carousel-mode="true" />
      </div>
    </div>
  </NuxtLayout>
</template>
<script setup>

const entity = useEntity();

const openSearch = () => {

  useState('isSearchOpen', () => false).value = true;

  if (process.client) {
    nextTick(() => {
      document.getElementById('txtSearch').focus();
    });
  }

};

</script>
<style lang="postcss">
.empty-group {
  @apply tracking-normal;

  &__block {
    @apply flex flex-col justify-between max-w-[500px] mx-auto p-6 text-center bg-neutral-50;

    &__desc {
      @apply text-xl my-4;
    }

    .button {
      @apply w-full;
    }
  }
}
</style>
